import moment from "moment";
import React from "react";
import { useTable } from "react-table";
import "../../../styles/print.css";
const PrintWithFooter = ({
  date,
  date1,
  columns,
  data,
  title,
  footer,
  customeHeader,
  marginTop,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });
  const companyName = localStorage.getItem("company");

  return (
    <div
      id="main"
      style={{
        width: columns.reduce((acc, row) => acc + Number(row.width), 0) + 50,
        border: "1px solid #888c89",
        borderRadius: "7px",
        height: "100%",
        backgroundColor: "white",
      }}
      className="flex flex-col items-center"
    >
      <div
        id="print-header"
        style={{
          width: columns.reduce((acc, row) => acc + Number(row.width), 0),
          border: "1px solid #888c89",
          borderRadius: "7px",
        }}
        className="  items-center  my-3"
      >
        <div style={{ width: "100%" }} className=" pt-3 px-5">
          <p
            className="flex justify-center items-center font-semibold"
            style={{ fontSize: "20px" }}
          >
            {companyName}
          </p>
        </div>
        <div
          style={{ width: "100%", flexGrow: "1", boxSizing: "border-box" }}
          className="flex justify-center items-center mt-1 bg-black"
        >
          <p className="flex justify-center ">
            {title ? title + "" + ":" : ""}{" "}
          </p>
          {date && (
            <>
              <input
                style={{ width: "9%" }}
                className="ml-3"
                value={date}
                readOnly
              />
              <p className="flex justify-center">To</p>

              <input
                style={{ width: "9%" }}
                className="ml-3"
                value={date1}
                readOnly
              />
            </>
          )}

          {customeHeader && customeHeader}
        </div>
      </div>

      <div id="print-component">
        <div
          style={
            window.innerWidth < 600
              ? {
                  width: "100%",
                  height: "auto",
                  overflow: "hidden",
                  marginTop: marginTop ? marginTop : "10%",
                  borderTop: "1px solid black",
                  borderLeft: "1px solid black",
                  borderRight: "1px solid black",
                }
              : {
                  width: "100%",
                  height: "auto",
                  overflow: "hidden",
                  marginTop: marginTop ? marginTop : "2.5%",
                  borderTop: "1px solid black",

                  borderLeft: "1px solid black",
                  borderBottom: "1px solid black",
                }
          }
          className={` `}
        >
          {headerGroups.map((headerGroup, key) => (
            <tr
              style={{ fontSize: "14px" }}
              key={key}
              className="bg-white] text-black  "
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column, index) => (
                <td
                  {...column.getHeaderProps()}
                  key={index}
                  className="whitespace-nowrap  text-center py-2 "
                  style={
                    columns[index].width
                      ? {
                          minWidth: columns[index].width,
                          fontWeight: 500,
                          borderRight: "1px solid #888c89",
                        }
                      : {
                          flex: columns[index].flex,
                          fontWeight: 500,
                          borderRight: "1px solid #888c89",
                        }
                  }
                >
                  {/* {columns[index].width} */}

                  {columns[index].renderHeader().props.children}
                </td>
              ))}
            </tr>
          ))}
        </div>
        <div
          style={
            window.innerWidth < 600
              ? {
                  width: "100%",
                  height: "auto",
                  overflow: "hidden",
                }
              : {
                  width: "100%",
                  height: "auto",
                  overflow: "hidden",
                }
          }
        >
          <table
            {...getTableProps()}
            style={{
              width: columns.reduce((acc, row) => acc + Number(row.width), 0),
            }}
            className="w-full   border-t-0 "
          >
            <thead className="">
              {headerGroups.map((headerGroup, key) => (
                <tr
                  key={key}
                  style={{ fontSize: "15px" }}
                  className="text-white "
                  {...headerGroup.getHeaderGroupProps()}
                >
                  {headerGroup.headers.map((column, index) => (
                    <td
                      {...column.getHeaderProps()}
                      key={index}
                      className="whitespace-nowrap  text-center bg-[#0d0d0d]"
                      style={
                        columns[index].width
                          ? {
                              minWidth: columns[index].width,
                              fontWeight: 500,
                            }
                          : {
                              flex: columns[index].flex,
                              fontWeight: 500,
                              borderRight: "1px solid #888c89",
                            }
                      }
                    ></td>
                  ))}
                </tr>
              ))}
            </thead>

            <tbody
              {...getTableBodyProps()}
              className=" w-full"
              style={{ borderLeft: "1px solid #b5b3b3" }}
            >
              {rows.map((row, rowIndex) => {
                prepareRow(row);
                return (
                  <tr
                    className="hover:cursor-pointer"
                    {...row.getRowProps()}
                    key={rowIndex}
                  >
                    {row.cells.map((cell, i) => {
                      return (
                        <td
                          {...cell.getCellProps()}
                          style={{
                            borderRight: "1px dashed #b5b3b3",
                            borderTop:
                              rowIndex === 0
                                ? "0 dashed #b5b3b3"
                                : "1px dashed #b5b3b3",
                            borderBottom: "1px dashed #b5b3b3",
                            maxWidth: cell.column.width,

                            fontSize: "14px",
                            whiteSpace: "normal",
                          }}
                          key={i}
                          className="h-[100px]"
                        >
                          <div
                            style={{
                              textAlign: cell.render("Cell").props.cell.column
                                .align
                                ? cell.render("Cell").props.cell.column.align
                                : "left",
                              whiteSpace: "normal",
                            }}
                            className=" p-2  h-[100px] "
                          >
                            <div>
                              {!cell.column.editable ? (
                                cell.render("Cell").props.cell.column.type ===
                                "date" ? (
                                  moment(
                                    cell.render("Cell").props.cell.value
                                  ).format("DD-MM-YYYY")
                                ) : cell.render("Cell").props.cell.value ===
                                    "0.00" ||
                                  cell.render("Cell").props.cell.value === 0 ||
                                  cell.render("Cell").props.cell.value ===
                                    "0" ? (
                                  " "
                                ) : cell.column.renderCell ? (
                                  cell.column.renderCell(
                                    cell.render("Cell").props.cell
                                  )
                                ) : (
                                  cell.render("Cell")
                                )
                              ) : (
                                <input
                                  type={
                                    cell.column?.type
                                      ? cell.column.type
                                      : "text"
                                  }
                                  id={
                                    cell.row.original.id +
                                    "-" +
                                    cell.column.field
                                  }
                                  className="outline-none w-full"
                                  value={cell.value}
                                />
                              )}
                            </div>
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>

          {footer && footer}
        </div>

        <div className="w-full flex justify-between">
          <div
            style={{
              fontSize: "12px",
            }}
            className="flex  pt-2"
          >
            <span style={{ fontSize: "10px", color: "#3b3a39" }}>
              {" "}
              Powered by{" "}
            </span>{" "}
            <span
              style={{ fontSize: "11px", color: "#171716" }}
              className="pl-1"
            >
              geniusoffice{" "}
            </span>
          </div>
          <div className="flex pt-2 items-center ">
            <div
              style={{
                fontSize: "11px",
                color: "#3b3a39",
                fontWeight: "600px",
              }}
            >
              Date :{" "}
            </div>

            <div
              style={{
                fontSize: "10px",
                color: "#3b3a39",
                fontWeight: "500px",
              }}
              className="pl-1"
            >
              {moment().format("DD-MM-yyyy HH:mm ")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintWithFooter;
